import { DesktopSectionToolbar } from "@/shared/ui/navigation/DesktopSectionToolbar";

interface DesktopSearchToolbarProps {
  onScrollToBottom: () => void;
  onScrollToTop: () => void;
  onSettingsClick: React.MouseEventHandler<HTMLAnchorElement>;
  onToggleSidebar: () => void;
}

/** 履歴ページのツールバーから、検索画面に不要な更新操作を除いたPC版ナビゲーション。 */
export function DesktopSearchToolbar({
  onScrollToBottom,
  onScrollToTop,
  onSettingsClick,
  onToggleSidebar,
}: DesktopSearchToolbarProps): React.ReactElement {
  return (
    <DesktopSectionToolbar
      ariaLabel="投稿検索ナビゲーション"
      onToggleSidebar={onToggleSidebar}
      onScrollToTop={onScrollToTop}
      onScrollToBottom={onScrollToBottom}
      onSettingsClick={onSettingsClick}
      secondaryAriaLabel="投稿検索操作"
    />
  );
}
